import { Address, generateAddressFG } from './address.model';
import { Phone } from './phone.model';
import { Representative, generateRepresentativeFG } from './representative.model';
import { SelectOption } from './select-option.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

export interface LegalPerson {
    cuit: string;
    razonSocial: string;
    tipoSociedad: string;
    email?: string;
    rubro: SelectOption;
    situacionIVA: SelectOption;
    celular: Phone;
    direccion: Address;
    representante?: Representative;
    tipoSociedadPersonalizado?: string;
    rubroPersonalizado?: string;
}

export function generateLegalPersonFG(withRepresentative = true) {
    return new UntypedFormGroup({
        cuit: new UntypedFormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]),
        razonSocial: new UntypedFormControl('', [Validators.required]),
        tipoSociedad: new UntypedFormControl('', [Validators.required]),
        tipoSociedadPersonalizado: new UntypedFormControl('', []),
        rubro: new UntypedFormControl('', [Validators.required]),
        rubroPersonalizado: new UntypedFormControl('', []),
        situacionIVA: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        direccion: generateAddressFG(),
        representante: withRepresentative ? generateRepresentativeFG() : new UntypedFormControl([], [])
    });
}
